import PersistenceRegistry from '../base/redux/PersistenceRegistry';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { BACKGROUND_ENABLED, SET_VIRTUAL_BACKGROUND, SET_VIRTUAL_BACKGROUND_ENABLED } from './actionTypes';
const STORE_NAME = 'features/virtual-background';
const DEFAULT_STATE = {
    backgroundEffectEnabled: undefined,
    backgroundType: undefined,
    blurValue: undefined,
    selectedThumbnail: undefined,
    virtualSource: undefined,
    isvirtualBackgroundEnable: undefined
};
const filterSubtree = {};
// start with the default state
Object.keys(DEFAULT_STATE).forEach(key => {
    const key1 = key;
    if (key1 !== 'isvirtualBackgroundEnable') {
        // @ts-ignore
        filterSubtree[key1] = true;
    }
});
/**
 * Reduces redux actions which activate/deactivate virtual background image, or
 * indicate if the virtual image background is activated/deactivated. The
 * backgroundEffectEnabled flag indicate if virtual background effect is activated.
 *
 * @param {State} state - The current redux state.
 * @param {Action} action - The redux action to reduce.
 * @param {string} action.type - The type of the redux action to reduce..
 * @returns {State} The next redux state that is the result of reducing the
 * specified action.
 */
ReducerRegistry.register(STORE_NAME, (state = {}, action) => {
    const { virtualSource, backgroundEffectEnabled, blurValue, backgroundType, selectedThumbnail, isvirtualBackgroundEnable } = action;
    /**
     * Sets up the persistence of the feature {@code virtual-background}.
     */
    PersistenceRegistry.register(STORE_NAME, filterSubtree, DEFAULT_STATE);
    // PersistenceRegistry.register(STORE_NAME, {
    //     exclude: ['isvirtualBackgroundEnable']
    //   });
    switch (action.type) {
        case SET_VIRTUAL_BACKGROUND: {
            return {
                ...state,
                virtualSource,
                blurValue,
                backgroundType,
                selectedThumbnail
            };
        }
        case SET_VIRTUAL_BACKGROUND_ENABLED: {
            return {
                ...state,
                isvirtualBackgroundEnable: isvirtualBackgroundEnable
            };
        }
        case BACKGROUND_ENABLED: {
            return {
                ...state,
                backgroundEffectEnabled
            };
        }
    }
    return state;
});
